import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DelegationsListComponent } from './delegations-types-list/delegations-list.component';
import { DelegationsDetailComponent } from './delegations-types-detail/delegations-detail.component';

const routes: Routes = [
    {
        path: 'delegations',
        children: [
            { path: '', component: DelegationsListComponent }
        ]
    },
    {
        path: 'delegations/:id',
        children: [
            { path: '', component: DelegationsDetailComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DelegationsRoutingModule { }
